import { db } from './config';
import { doc, setDoc, getDoc, onSnapshot } from 'firebase/firestore';
import { useEffect, useState } from 'react';

// Function to update payment settings
export const updatePaymentSettings = async (settings) => {
  try {
    await setDoc(doc(db, 'settings', 'payments'), settings, { merge: true });
    return { success: true };
  } catch (error) {
    console.error('Error updating payment settings:', error);
    return { success: false, error };
  }
};

// Custom hook to get payment settings
export const usePaymentSettings = () => {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    const settingsRef = doc(db, 'settings', 'payments');
    const unsubscribe = onSnapshot(settingsRef, (doc) => {
      if (doc.exists()) {
        setSettings(doc.data());
      }
    });

    return () => unsubscribe();
  }, []);

  return settings;
}; 